package com.arena_web.ui.theme

/**
 * Fake player records used to populate preview cards in tooltips, design-system
 * showcases, and other places where we want to render the real-looking card
 * without depending on a backend response.
 */
data class DemoPlayer(
    val avatarUrl: String,
    val name: String,
    val rating: Int,
    val position: String,
    val sport: String,
    val cardFrameUrl: String,
    val ratingCardUrl: String,
    val flagUrl: String? = null,
    val teamEmblemUrl: String? = null,
)

object DemoPlayers {
    val Football: List<DemoPlayer> = listOf(
        DemoPlayer(
            avatarUrl = AppIcons.DemoPlayer,
            name = "KUSHPEL",
            rating = 84,
            position = "CM",
            sport = "football",
            cardFrameUrl = "https://images.arenaproplay.com/cards/football/card.png",
            ratingCardUrl = "https://images.arenaproplay.com/cards/football/card_rating.png",
            flagUrl = AppIcons.DemoFlag,
            teamEmblemUrl = AppIcons.DemoTeamEmblem,
        ),
    )
}
